import uuid from 'uuid/v4';

import api from '../lib/api';
import {
  findCurrentUserMembership,
} from '../selectors/purchase-selector';
import {
  hideMobileModal,
  showAlert,
  ALERT_DASHBOARD_MEMBERS_REMOVED
} from './ui';
import { handle401 } from './error-handlers'

export const REQUEST_PURCHASE_MEMBERSHIPS = 'REQUEST_PURCHASE_MEMBERSHIPS';
export const FETCH_PURCHASE_MEMBERSHIPS = 'FETCH_PURCHASE_MEMBERSHIPS';

export const SET_CURRENT_MEMBERSHIP = 'SET_CURRENT_MEMBERSHIP';

export const REQUEST_REMOVE_MEMBERSHIP = 'REQUEST_REMOVE_MEMBERSHIP';
export const REMOVE_MEMBERSHIP = 'REMOVE_MEMBERSHIP';
export const REQUEST_REMOVE_MEMBERSHIPS = 'REQUEST_REMOVE_MEMBERSHIPS';
export const REMOVE_MEMBERSHIPS = 'REMOVE_MEMBERSHIPS';

export const fetchPurchaseMemberships = (id, perPage) => {
  return (dispatch) => {
    dispatch({
      type: REQUEST_PURCHASE_MEMBERSHIPS,
      payload: { id }
    });

    return api.get(`/purchases/${id}/memberships?pagination[per_page]=${perPage || 10}`)
      .then((response) => {
        return dispatch({
          type: FETCH_PURCHASE_MEMBERSHIPS,
          payload: { id, memberships: response.data }
        });
      });
  };
};

export function removeMembership(membershipId, authentication) {
  return (dispatch) => {
    dispatch({ type: REQUEST_REMOVE_MEMBERSHIP });
    return api.delete(`/memberships/${membershipId}`, {
      authorization: { bearer: authentication.token },
    })
    .then(() => {
      dispatch(hideMobileModal());
      dispatch(showAlert(ALERT_DASHBOARD_MEMBERS_REMOVED));
      dispatch({
        type: REMOVE_MEMBERSHIP,
        payload: { id: membershipId }
      });
    })
    .catch(handle401(dispatch));
  };
}

export function removeMemberships(memberships, authentication) {
  return (dispatch) => {
    const promises = memberships.map(member => dispatch(removeMembership(member.id, authentication)));
    dispatch({ type: REQUEST_REMOVE_MEMBERSHIPS });
    return Promise.all(promises).then(() => dispatch({ type: REMOVE_MEMBERSHIPS }));
  };
}

export function setCurrentMembership() {
  return (dispatch, getState) => {
    const state = getState();
    const currentMembership = findCurrentUserMembership(state);

    return dispatch({
      type: SET_CURRENT_MEMBERSHIP,
      payload: currentMembership ? currentMembership.id : uuid(),
    });
  };
}




// WEBPACK FOOTER //
// ./src/actions/memberships.js